import request from "./request";

export const baseURL = "http://jiaang.hongxuwuliu.com/xby/prod-api";
// export const baseURL = "http://192.168.0.155:8084/xby";
// export const baseURL = "http://192.168.0.190/xby/prod-api";
//网站基本信息
export function getInfo() {
  return request({
    url: "/data/api/hxBasicInformation/getInfo",
    method: "GET",
  });
}

//楼层
export function gethxFloor(data) {
  return request({
    url: "/data/api/hxFloor/" + data,
    method: "GET",
  });
}

//栏目列表
export function gethxColumn() {
  return request({
    url: "/data/api/hxColumn/list",
    method: "GET",
  });
}

//外链接
export function gethxLink() {
  return request({
    url: "/data/api/hxLink/list",
    method: "GET",
  });
}

//兴趣下拉
export function gethxInterest() {
  return request({
    url: "/data/api/hxInterest/list",
    method: "GET",
  });
}

//合作伙伴列表
export function gethxPartner() {
  return request({
    url: "/data/api/hxPartner/list",
    method: "GET",
  });
}

//报价提交
export function posthxQuotation(data) {
  return request({
    url: "/data/api/hxQuotation/add",
    method: "POST",
    data: data,
  });
}

//加入提交
export function posthxJoin(data) {
  return request({
    url: "/data/api/hxJoin/add",
    method: "POST",
    data,
  });
}
